import { Layout } from 'react-admin';
import React from 'react';
import { CustomMenu } from './CustomMenu';
import CustomAppBar from './CustomAppBar';

export const CustomLayout = props => <Layout {...props} menu={CustomMenu} appBar={CustomAppBar}/>;
